import { getQuery } from 'sutils';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

/**
 * 是否是远程演示测试环境
 * @return {*|boolean}
 */
export function isRemotePlayerTest(): boolean {
    const query = getQuery('sceneSource');
    return ENV.IS_TEST && (query === 'MeetingRoom' || query === 'InEditor');
}
